import { getDownloadLogs, getLogsSyncMerchant, getLogsSyncMerchantDetail } from '../../utils/api';
import { actionTypes } from './constants';

export function setFailedAction({ key, message, error }) {
  return { type: actionTypes.FAILED, key, message, error };
}

export function setLoadingAction({ key, loading = true }) {
  return { type: actionTypes.LOADING, key, loading };
}

export function setSuccessAction({
  key,
  data,
  meta = {},
  message = '',
  success = true
}) {
  return { type: actionTypes.SUCCESS, key, data, meta, message, success };
}

export function setFilterAction({ key, filter = {} }) {
  return { type: actionTypes.FILTER, key, filter };
}

export function setMessageAction({ key, message }) {
  return { type: actionTypes.MESSAGE, key, message };
}

export function fetchLogSyncMerchant(
  search,
  filter,
  nextPage = 1,
  initial = false,
) {
  return async (dispatch, getState) => {
    const key = 'table';
    const state = getState();
    const { page, totalPage } = state.logsSyncMerchant[key].meta;
    if (!initial && page > 1 && page >= totalPage) {
      return;
    } else {
      try {
        const params = {
          ...filter,
          search,
          size: 100,
          page: nextPage,
        };
        dispatch(setLoadingAction({ key }));
        const response = await getLogsSyncMerchant(params);
        const { meta } = response;
        const data = initial
          ? response.data
          : [...state.logsSyncMerchant[key].data, ...response.data];
        dispatch(setSuccessAction({ key, data, meta }));
      } catch (error) {
        const { message } = error;
        dispatch(setFailedAction({ key, message }));
      }
    }
  };
}

export function fetchLogSyncMerchantDetail(id) {
  return async (dispatch) => {
    const key = 'detail';
    try {
      dispatch(setLoadingAction({ key }));
      const response = await getLogsSyncMerchantDetail(id);
      const { data } = response;
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchDownloadLogs(filter, search, password) {
  return async (dispatch) => {
    const key = 'download';
    try {
      const params = {
        ...filter,
        search,
        password
      };
      dispatch(setLoadingAction({ key }));
      const { data } = await getDownloadLogs(params);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}
